import React, { useState } from 'react'
import { Accordion, Card, Button } from "react-bootstrap";
import {
    Actions,
    Loading,
    Table as TableComponent,
} from "../../../Components";
import * as QLIBS from '../../../qLibsHelpers';
import { DEFAULT_HEADER } from '../../../Config/userToken';
import { APPCONFIG } from '../../../app.config';
import moment from 'moment';
import { APIS } from '../../../Config/apis';


const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

const requestOptions = {
    method: 'GET',
    headers: DEFAULT_HEADER.get()
};

const SectionEnum = {
    Certificados: 1,
    DireccionPoliza: 2,
    Coberturas: 3,
    Beneficiarios: 4,
    ComposicionPremio: 5,
    FormaDePago: 6,
    Facturacion: 7,
    Rechazos: 8
};

const initSections = [
    {
        id: SectionEnum.Certificados,
        title: 'Certificados',
        loaded: false,
        enabled: true,
        core: 'EOS'
    },
    {
        id: SectionEnum.DireccionPoliza,
        title: 'Dirección de Póliza',
        loaded: false,
    },
    {
        id: SectionEnum.Coberturas,
        title: 'Coberturas',
        loaded: false,
        enabled: true,
        core: 'EOS'
    },
    {
        id: SectionEnum.Beneficiarios,
        title: 'Beneficiarios',
        enabled: true,
        loaded: false,
        core: 'EOS'
    },
    {
        id: SectionEnum.ComposicionPremio,
        title: 'Composición de Premio',
        loaded: false,
        secondLevel: true,
        enabled: true
    },
    {
        id: SectionEnum.FormaDePago,
        title: 'Forma de Pago',
        loaded: false
    },
    {
        id: SectionEnum.Facturacion,
        title: 'Facturación',
        loaded: false,
        enabled: true,
        download: true,
        expandable: true
    },
    {
        id: SectionEnum.Rechazos,
        title: 'Rechazos',
        loaded: false,
        enabled: true,
        secondLevel: true
    }
];

function dateFormat(val) {
    return val ? moment(val).format('DD/MM/YYYY') : null;
}

function moneyFormat(val) {
    return val ? "$ " + val.toLocaleString("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) : null;
};

const columnsDef = {
    [SectionEnum.Certificados]: {
        "certificadoNumero": { title: "Nro. Certificado" },
        "nombreAsegurado": { title: "Nombre" },
        "apellidoAsegurado": { title: "Apellido" },
        "numeroDniAsegurado": { title: "DNI" },
        "capitalAsegurado": { title: "Capital asegurado" },
        "sexoAsegurado": { title: "Sexo" },
    },
    [SectionEnum.DireccionPoliza]: {
        "SRECTYPEDESC": { title: "Tipo" },
        "SDESCADD": { title: "Dirección" },
        "SZIP_CODE": { title: "Código Postal" },
        "NLOCALDESC": { title: "Localidad" },
        "NPROVINCEDESC": { title: "Provincia" },
        "NCOUNTRYDESC": { title: "País" },
        "SE_MAIL": { title: "Correo electrónico" }
    },
    [SectionEnum.Coberturas]: {
        "NCOVERDESC": { title: " Nombre Cobertura" },
        "NCAPITAL": { title: "Suma Asegurada" },
        "DEFFECDATE": { title: " Fecha Vigencia Desde", format: dateFormat }, // TODO: falta incluir este campo en el response
    },
    [SectionEnum.Beneficiarios]: {
        "SCLIENTDESC": { title: "Nombre" },
        "DBIRTHDAT": { title: " Fecha de Nacimiento", format: dateFormat },
        "NPARTICIP": { title: "Porcentaje de participación" },
        "NGROUPBEN": { title: "Orden Beneficiario" },
        "NRELATIONDESC": { title: "Relación" }
    },
    // [SectionEnum.ComposicionPremio]: {
    //     "STYPE_DETAIDESC": { title: "Tipo Registro" },
    //     "NDISSUR_TYPEDESC": { title: "Subtipos recargo" },
    //     "NPREMIUM": { title: "Total importe" }       
    // },
    [SectionEnum.ComposicionPremio]: {
        "CONCEPTO": { title: "Concepto", width: 200 },
        "DESCRIPCION": { title: "Descripción", width: 500 },
        "PRIMA": { title: "Monto", format: moneyFormat, summarize: true, signo: '$' }
    },
    [SectionEnum.FormaDePago]: {
        "SCLIENTDESC": { title: "Nombre" },
        "NTYP_CRECARDDESC": { title: "Tipo Tarjeta" },
        "SCREDI_CARDCONFIDENTIALIT": { title: "Número de Tarjeta" },
        "DCARDEXPIR": { title: "Fecha vencimiento de Tarjeta de Crédito", format: dateFormat },
        "NBANKEXTDESC": { title: "Banco" },
        "SCBU": { title: "Código CB" }
    },
    [SectionEnum.Facturacion]: {
        "FacturaNumero": { title: "Nro. Factura" },
        "FechaEmision": { title: "Fecha Emisión", displayFormat: 'date' },
        "FechaInicioVigencia": { title: "Fecha Inicio vigencia", displayFormat: 'date' },
        "FechaFinVigencia": { title: "Fecha Fin vigencia", displayFormat: 'date' },
        "FechaConfirmacion": { title: "Última Aplicación", displayFormat: 'date' },
        "FechaVencimiento": { title: "Fecha de vencimiento", displayFormat: 'date' },
        "MontoCobro": { title: "Premio", displayFormat: 'money', alignRight: true },
        "MontoAdeudado": { title: "Saldo Pendiente", displayFormat: 'money', alignRight: true },
        "EstadoFacturaDescripcion": { title: "Estado" },
    },
    [SectionEnum.Rechazos]: {
        "DLEDGERDAT": { title: "Fecha Movimiento", format: dateFormat },
        "BULLETINSNCOD_AGREEDESC": { title: "Medio de Pago" },
        "NPAYREJECTDESC": { title: "Causa de Rechazo" },
        "NBALANCE": { title: "Saldo" },
        "NBULLETINS": { title: "Cupon" }
    }
};

const apiMethods = {
    [SectionEnum.Certificados]: (props) => `certificados?agreBaseKey=${props.original.agreBaseKey}`,
    [SectionEnum.DireccionPoliza]: (props) => `producer/GetDirecciones?poliza=${props.original.agreBaseKey}`,
    [SectionEnum.Coberturas]: (props) => `Producer/GetCoberturas?poliza=${props.original.agreBaseId}`,
    [SectionEnum.Beneficiarios]: (props) => `Producer/GetBeneficiarios?poliza=${props.original.agreBaseId}`,
    [SectionEnum.FormaDePago]: (props) => `GetFormaPago?idRamo=${props.original.ramo}&idProducto=${props.original.productCodeVt}&idCertificado=${props.original.certificateNumber}&poliza=${props.original.policyNumberVt}`,
    [SectionEnum.Facturacion]: (props) => `producer/GetFacturas?policyKey=${props.original.agreBaseKey}&branch=${props.original.ramo}&policyNumber=${props.original.polizaNumeroFormatoVT}&productCode=${props.original.codigoProductoVT}`,
    [SectionEnum.ComposicionPremio]: (props) => `producer/premium?factura=${props.original.NRECEIPT}`,
    [SectionEnum.Rechazos]: (props) => `producer/rejections?branch=${props.original.ramo}&policy=${props.original.polizaNumero}&invoice=${props.original.NRECEIPT}`
};

class PolicyDetailGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: this.getColumns(props),
            policy: props.original,
            data: [],
            loading: false,
            width: (props.width === undefined || props.width === null) ? '100%' : props.width.toString() + 'px'
        };
    }
    getColumns(props) {
        const section = initSections.find(e => e.id === props.id);
        const columns = QLIBS.getTableColumns(columnsDef[props.id])
        if (section.download) {
            columns.unshift({
                Header: section.downloadName || "Factura",
                accessor: "actions",
                width: 100,
                style: {
                    display: 'flex',
                    alignItems: 'center'
                },
                filterable: false,
                sortable: false,
                resizable: true,
                Cell: row => (
                    <Actions
                        hidden={!row.original.CanDownload}
                        icon="fas fa-file-download"
                        onDownload={() => props.id === SectionEnum.Facturacion ? this.downloadPdfInvoice(row.row) : this.downloadCertificate(row)}
                    />
                )
            });
        }
        return columns;
    }

    downloadPdfInvoice = (row) => {
        this.setState({ loading: true });
        const requestOptions = {
            method: 'GET',
            headers: DEFAULT_HEADER.get(),
        };
        const PRODUCERURL = APIS.URLS.DOWNLOAD_INVOICE;

        const policyInformation = this.state.policy;
        fetch(`${PRODUCERURL}?invoiceNumber=${row.FacturaNumero}&branch=${policyInformation.ramo}&policyNumber=${policyInformation.polizaNumeroFRMT}&productCode=${policyInformation.codigoProductoVT}`, requestOptions)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                } else {
                    const errorText = await response.text();
                    let errorMessage = "Ocurrió un error.";
                    try {
                        const errorData = JSON.parse(errorText);
                        if (errorData.errors && Array.isArray(errorData.errors)) {
                            errorMessage = errorData.errors.join(" - ");
                        } else {
                            errorMessage = errorData.message || errorText;
                        }
                    } catch (e) {
                        errorMessage = errorText;
                    }
                    throw new Error(errorMessage);
                }
            })
            .then(data => {
                const byteArray = Uint8Array.from(atob(data.base64), c => c.charCodeAt(0));
                const blob = new Blob([byteArray], { type: data.mime_type || 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = data.name;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                this.setState({ showModal: true, modalMsg: 'No se pudo descargar la factura.' });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    componentDidMount() {
        this.setState({ loading: true });
        fetch(`${PRODUCERURL}api/${apiMethods[this.props.id](this.props)}`, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                const dataArray = data;
                const cols = columnsDef[this.props.id];
                if (dataArray.length) {
                    for (let entity of dataArray) {
                        for (let colName in cols) {
                            const col = cols[colName];

                            if (col && col.format) {
                                entity[colName] = col.format(entity[colName]);
                            }
                        }
                    }

                    this.setState({ data: dataArray });
                }

                this.setState({ loading: false });
            });
    }

    render() {

        return (
            <>
                <Loading visible={this.state.loading}></Loading>

                <div className="row my-3">
                    <div style={{ width: this.state.width }}>

                        <TableComponent
                            columns={this.state.columns}
                            data={this.state.data}
                            expandable={this.props.expandable}
                            subComponent={props => {
                                const propsJoin = Object.assign({}, { ...this.props }, { ...props }, { original: Object.assign({}, { ...this.props.original }, { ...props.original }) })

                                return (<PolicyRowDetail secondLevel={this.props.expandable} {...propsJoin} />)
                            }} />

                    </div>
                </div>
            </>
        );
    }
}



const PolicyRowDetail = (props) => {
    const filteredSections = initSections.filter(e => e.secondLevel === props.secondLevel)
    const [sections, setSections] = useState(JSON.parse(JSON.stringify(filteredSections)));

    const loadSection = (id) => {
        const section = sections.find(e => e.id === id);

        if (section.loaded) return;

        const expandable = section.expandable && !props.secondLevel

        section.loaded = true;
        section.grid = <PolicyDetailGrid  {...props} id={id} expandable={expandable} />;

        setSections(sections.slice());
    };

    const isEnabled = (section) => {
        return section.enabled;
    }
    return (

        <div className="m-4">
            <Accordion defaultActiveKey="0">
                {sections.map(e => (
                    <Card key={e.id}>
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                disabled={!isEnabled(e)}
                                variant="link"
                                eventKey={e.id}
                                onClick={() => loadSection(e.id)}
                            >
                                {e.title}
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey={e.id}>
                            <Card.Body>{e.grid}</Card.Body>
                        </Accordion.Collapse>
                    </Card>
                ))}
            </Accordion>
        </div>

    );
};

export default PolicyRowDetail;
